import React, { Component } from 'react';


const Contact = () => {
    return (


          <div className="container-fluid">

          <div className="h3">
          Contact
          </div>

          Email is always the best way to get in touch with Matt, text message or call is the next.
          <address>
             <i className="fa fa-envelope"></i>&nbsp;matt@denvercliffs.com<br />
             <i className="fa fa-phone"></i>&nbsp;720-280-6324<br />
             <a href="https://www.linkedin.com/in/matt-cliff-45a75b6/" target="_blank" rel="noopener noreferrer"  title="Linked In" >
                <i className="fa fa-linkedin"></i>https:\/\/www.linkedin.com/in/matt-cliff-45a75b6/</a>
          </address>


          </div>



    );
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Contact.js